define([], function () {
    function BreadCrumbsViewModel(initObject, when) {
        var self = this;
        this.crumbs = ko.observableArray(initObject.model.links);
        this.hereText = ko.observable(initObject.model.here);
        this.isCurrentLocationVisible = ko.observable(initObject.model.showCurrentLocationOnSmallScreens);
    }

    return BreadCrumbsViewModel;
});